module.exports = __webpack_public_path__ + "static/media/background.84bc59ae.jpg";